import Phaser from "phaser";
import LoadingScene from "@/games/MiningTutorial/scenes/LoadingScene";
import RoundStartScene from "@/games/MiningTutorial/scenes/RoundStartScene";
import QuestionScene from "@/games/MiningTutorial/scenes/QuestionScene";
import PlayScene from "@/games/MiningTutorial/scenes/PlayScene";
import BossScene from "@/games/MiningTutorial/scenes/BossScene";
import Settings from "@/games/MiningTutorial/scenes/Settings";
import LandingScene from "@/games/MiningTutorial/scenes/LandingScene";

function launch(containerId) {
  return new Phaser.Game({
    type: Phaser.AUTO,
    backgroundColor: 0xf5f5f5,
    parent: containerId,
    scale: {
      parent: containerId,
      mode: Phaser.Scale.FIT,
      autoCenter: Phaser.Scale.CENTER_BOTH,
      width: 480,
      height: 854,
    },
    dom: {
      createContainer: true,
    },
    scene: [
      LoadingScene,
      RoundStartScene,
      QuestionScene,
      PlayScene,
      BossScene,
      Settings,
      LandingScene,
    ],
  });
}

export default launch;
export { launch };
